import { Toro } from './../../api/common/enumerations';
import { authActionTypes } from './auth.actions';
import { Action, createReducer, on, State } from '@ngrx/store';
import { authAdapter, AuthState } from './auth.entity';
import { Constants } from '../../core/constants';


export const initialState = authAdapter.getInitialState({
    isUserLoggedIn: false,
    user: null,
    redirectUrl: '/dashboard',
    error: {
        error: null,
        errorMessageText: null,
        showResendLink: false,
    },
    rememberMe: null
});

const authReducer = createReducer(
    initialState,

    on(authActionTypes.LoginSuccess, (state, action) => ({
        ...state,
        user: action.user,
        rememberMe: action.rememberMe,
        isUserLoggedIn: true,
        error: null,
    })),

    on(authActionTypes.LogOutSuccess, (state) => ({
        ...state,
        user: null,
        isUserLoggedIn: false,
    })),

    on(authActionTypes.UserDetailsSuccess, (state, action) => ({
        ...state,
        user: action.user,
        isUserLoggedIn: true,
    })),
    on(authActionTypes.LoginFailure, (state, action) => {
        let out = getErrorMessage(action.error);
        return authAdapter.addOne(
            action.error,
            {
                ...state,
                error: {
                    error: action.error,
                    errorMessageText: out.errorMessageText,
                    showResendLink: out.showResendLink
                }
            });

    })

);

function getErrorMessage(error) {
    if (error && error.status === Toro.HttpResponseStatusCode.Unauthorized) {
        let out = {
            errorMessageText: 'Username or password is incorrect.',
            showResendLink: false
        }

        return out;
    }
    else if (error && error.statusText === Constants.Strings.CallerVerificationIncomplete) {
        let out = {
            errorMessageText: 'Your email address has not been verified. Follow instructions in the verification email to complete your registration.',
            showResendLink: true
        }
        return out;
    }
    else {
        return {
            errorMessageText: '',
            showResendLink: false
        }
    }
}

export function authReducerFn(state = initialState, action: Action): AuthState {
    return authReducer(state, action);
}

export const { selectAll } = authAdapter.getSelectors();
